module.exports = __webpack_public_path__ + "img/live-3.9e196d93.png";